// Date helpers — app standardises on dd/mm/yyyy display while keeping
// ISO YYYY-MM-DD as the storage / API format.

export const toDDMMYYYY = (iso) => {
  if (!iso) return '';
  // Accept either "YYYY-MM-DD" or ISO datetime
  const str = String(iso).slice(0, 10);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str);
  if (!m) return iso;
  return `${m[3]}/${m[2]}/${m[1]}`;
};

export const toISO = (ddmmyyyy) => {
  if (!ddmmyyyy) return '';
  const m = /^(\d{2})[/-](\d{2})[/-](\d{4})$/.exec(ddmmyyyy);
  if (!m) return ddmmyyyy;
  return `${m[3]}-${m[2]}-${m[1]}`;
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const addDaysISO = (iso, days) => {
  const d = iso ? new Date(iso) : new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};
